<div *ngIf="nodeValue" class="bg-bluegray-50 h-full">
   <div
      class="bg-white flex flex-column justify-content-between align-items-center gap-3 w-full px-3"
   >
      <span class="cursor-pointer w-full justify-content-end flex pt-4 mr-2" (click)="this.closeSidebar.emit()">
         <i class="text-bluegray-800 pi pi-times"></i>
      </span>

      <div class="flex justify-content-start align-items-center w-full gap-3 pb-3">
         <div class="bg-blue-50 p-3 border-1 border-blue-100 border-round-lg">
            <i class="pi pi-shield text-blue-700 text-lg"></i>
         </div>
         <div class="text-2xl text-700 font-semibold flex flex-column gap-1">
            {{ 'DATA.MODULES.INSPECTORS.SMS_CERTIFIED.TITLE' | translate }}
            <div class="text-sm font-normal text-600">
               {{ 'DATA.MODULES.INSPECTORS.SMS_CERTIFIED.DESCRIPTION' | translate }}
            </div>
         </div>
      </div>

      <div *ngIf="visibleTabs().length > 1" class="tab-nav tab-nav--centered w-full">
         <button
            *ngFor="let tab of visibleTabs()"
            type="button"
            class="tab-nav__item"
            [class.tab-nav__item--active]="activeTab() === tab.value"
            (click)="activeTab.set(tab.value)"
         >
            <lucide-icon *ngIf="tab.value === 'preview'" name="eye" [size]="15"></lucide-icon>
            <lucide-icon *ngIf="tab.value === 'config'" name="settings" [size]="15"></lucide-icon>
            <span>{{ tab.label }}</span>
         </button>
      </div>
   </div>

   <!-- Preview tab -->
   <div *ngIf="activeTab() === 'preview'" class="p-3 pb-4">
      <div class="flex flex-column gap-4">
         <!-- Phone Mockup -->
         <div class="flex justify-content-center">
            <div class="phone-mockup shadow-4 border-round-3xl bg-white overflow-hidden flex flex-column flex-shrink-0">
               <div
                  class="phone-header bg-gray-100 p-3 flex align-items-center justify-content-center border-bottom-1 border-200"
               >
                  <div class="flex align-items-center gap-2">
                     <div
                        class="bg-blue-500 text-white border-circle w-2rem h-2rem flex align-items-center justify-content-center"
                     >
                        <i class="text-white pi pi-user"></i>
                     </div>
                     <span class="font-bold text-sm text-700">Paymefy</span>
                  </div>
               </div>

               <div class="phone-content p-3 flex flex-column bg-gray-50 flex-grow-1 overflow-y-auto">
                  <div *ngIf="previewMessage()" class="flex flex-column gap-1 align-self-start max-w-12rem">
                     <span class="text-xs text-500 px-2 font-medium" *ngIf="selectedTemplateName()">
                        {{ selectedTemplateName() }}
                     </span>
                     <div
                        class="sms-bubble sent bg-blue-100 text-blue-900 p-3 border-round-xl shadow-1 line-height-3 relative text-sm"
                     >
                        {{ previewMessage() }}
                        <div class="text-right text-xs text-blue-400 mt-1">10:45</div>
                     </div>
                  </div>

                  <div
                     *ngIf="!previewMessage()"
                     class="flex flex-column align-items-center justify-content-center h-full text-400 opacity-60 italic py-5"
                  >
                     <i class="pi pi-comment text-4xl mb-2"></i>
                     <span>{{ 'DATA.MODULES.INSPECTORS.SMS_CERTIFIED.CONFIG.TEMPLATE_HELP' | translate }}</span>
                  </div>
               </div>

               <div class="phone-footer bg-white p-3 border-top-1 border-200 flex align-items-center gap-2">
                  <div class="bg-gray-100 border-round-2xl px-3 py-2 text-400 text-xs flex-grow-1">Text Message</div>
                  <i class="pi pi-send text-blue-500"></i>
               </div>
            </div>
         </div>

         <div class="flex flex-column gap-3">
            <div
               class="surface-card p-4 border-1 border-round-xl border-blue-100 flex flex-row gap-4 align-items-start"
            >
               <div class="bg-blue-50 border-round-xl flex align-items-center justify-content-center w-3rem h-3rem flex-shrink-0">
                  <i class="pi pi-shield text-blue-700 text-lg"></i>
               </div>

               <div class="flex flex-column gap-2 flex-grow-1">
                  <span class="font-medium text-500">{{ 'DATA.MODULES.INSPECTORS.SMS_CERTIFIED.PREVIEW.TEMPLATES_LABEL' | translate }}</span>
                  <div *ngIf="selectedTemplates().length; else noTemplates" class="flex flex-column gap-1">
                     <span
                        *ngFor="let tpl of selectedTemplates()"
                        class="text-base font-semibold text-blue-800 text-xl"
                     >{{ tpl.name }}</span>
                  </div>
                  <ng-template #noTemplates>
                     <span class="text-sm text-400 italic">—</span>
                  </ng-template>
               </div>
            </div>

            <div
               class="surface-card p-4 border-1 border-round-xl border-blue-100 flex flex-row gap-4 align-items-center"
            >
               <div class="bg-teal-50 border-round-xl flex align-items-center justify-content-center w-3rem h-3rem">
                  <i class="pi pi-clock text-teal-700 text-lg"></i>
               </div>

               <div class="flex flex-column gap-1">
                  <span class="font-medium text-500">{{
                     'DATA.MODULES.INSPECTORS.SMS_CERTIFIED.PREVIEW.EXPIRATION_LABEL' | translate
                  }}</span>
                  <span class="text-blue-800 font-semibold text-xl" *ngIf="expirationMode() === 'days'">
                     {{ 'DATA.MODULES.INSPECTORS.SMS_CERTIFIED.PREVIEW.EXPIRES_IN' | translate }}
                     {{ expirationDays() ?? 0 }}
                     {{
                        (expirationDays() ?? 0) === 1
                           ? ('DATA.COMMON.TIME.DAY' | translate)
                           : ('DATA.COMMON.TIME.DAYS' | translate)
                     }}
                  </span>
                  <span class="text-blue-800 font-semibold text-xl" *ngIf="expirationMode() === 'date'">
                     {{ expirationAt() | date: 'dd/MM/yyyy' }}
                  </span>
               </div>
            </div>

            <div
               class="surface-card p-4 border-1 border-round-xl border-blue-100 flex flex-row gap-4 align-items-center"
            >
               <div class="bg-cyan-50 border-round-xl flex align-items-center justify-content-center w-3rem h-3rem">
                  <i class="pi pi-send text-cyan-700 text-lg"></i>
               </div>

               <div class="flex flex-column gap-1">
                  <span class="font-medium text-500">{{
                     'DATA.MODULES.INSPECTORS.SMS_CERTIFIED.PREVIEW.SEND_TO_ALL_LABEL' | translate
                  }}</span>
                  <span class="text-xl font-semibold text-blue-800">
                     {{ sendToAllContacts() ? ('GLOBAL.YES' | translate) : ('GLOBAL.NO' | translate) }}
                  </span>
               </div>
            </div>

            <div *ngIf="errors().length" class="mt-4">
               <div *ngFor="let e of errors()" class="text-red-600 text-sm">{{ e.errorMessage }}</div>
            </div>
         </div>
      </div>
   </div>

   <!-- Config tab -->
   <div *ngIf="activeTab() === 'config'" class="p-3 pb-4">
      <div class="flex flex-column gap-4">
         <!-- Multi-template selector -->
         <div class="flex flex-column gap-2">
            <label class="font-semibold text-800">{{
               'DATA.MODULES.INSPECTORS.SMS_CERTIFIED.CONFIG.TEMPLATE_LABEL' | translate
            }}</label>
            <span class="text-500 text-sm mb-1">{{
               'DATA.MODULES.INSPECTORS.SMS_CERTIFIED.CONFIG.TEMPLATE_HELP' | translate
            }}</span>
            <p-multiSelect
               [options]="templates()"
               [ngModel]="selectedTemplateIds()"
               (ngModelChange)="onTemplatesChange($event)"
               optionLabel="name"
               optionValue="id"
               [placeholder]="'DATA.MODULES.INSPECTORS.SMS_CERTIFIED.CONFIG.TEMPLATE_PLACEHOLDER' | translate"
               styleClass="w-full"
               [filter]="true"
               display="chip"
               appendTo="body"
            ></p-multiSelect>
         </div>

         <div *ngIf="previewMessage()" class="mt-2">
            <div class="bg-blue-50 p-3 border-round-lg border-1 border-blue-200">
               <div class="font-semibold text-700 mb-2 flex align-items-center gap-2">
                  <i class="pi pi-align-left"></i>
                  {{ selectedTemplateName() }}
               </div>
               <div class="text-700 line-height-3 whitespace-pre-wrap">
                  {{ previewMessage() }}
               </div>
            </div>
         </div>

         <p-divider></p-divider>

         <div class="flex flex-column gap-3">
            <label class="font-semibold text-800">{{
               'DATA.MODULES.INSPECTORS.SMS_CERTIFIED.CONFIG.EXPIRATION_MODE_LABEL' | translate
            }}</label>

            <div class="flex gap-4">
               <div class="flex align-items-center">
                  <p-radioButton
                     name="expMode"
                     value="days"
                     [ngModel]="expirationMode()"
                     (ngModelChange)="onExpirationModeChange($event)"
                     inputId="expDays"
                  ></p-radioButton>
                  <label for="expDays" class="ml-2 cursor-pointer">{{
                     'DATA.MODULES.INSPECTORS.SMS_CERTIFIED.CONFIG.EXPIRATION_MODE_DAYS' | translate
                  }}</label>
               </div>
               <div class="flex align-items-center">
                  <p-radioButton
                     name="expMode"
                     value="date"
                     [ngModel]="expirationMode()"
                     (ngModelChange)="onExpirationModeChange($event)"
                     inputId="expDate"
                  ></p-radioButton>
                  <label for="expDate" class="ml-2 cursor-pointer">{{
                     'DATA.MODULES.INSPECTORS.SMS_CERTIFIED.CONFIG.EXPIRATION_MODE_DATE' | translate
                  }}</label>
               </div>
            </div>

            <div *ngIf="expirationMode() === 'days'" class="flex flex-column gap-2 mt-2">
               <p-inputNumber
                  type="number"
                  min="0"
                  max="365"
                  styleClass="w-full"
                  [ngModel]="expirationDays()"
                  (ngModelChange)="onExpirationDaysChange($event)"
                  [suffix]="'DATA.MODULES.INSPECTORS.SMS_CERTIFIED.CONFIG.DAYS_SUFFIX' | translate"
               />
            </div>

            <div *ngIf="expirationMode() === 'date'" class="flex flex-column gap-2 mt-2">
               <p-calendar
                  [ngModel]="expirationAt()"
                  (ngModelChange)="onExpirationAtChange($event)"
                  [showIcon]="true"
                  appendTo="body"
                  styleClass="w-full"
                  [minDate]="today"
                  dateFormat="dd/mm/yy"
                  placeholder="dd/mm/yyyy"
               ></p-calendar>
            </div>
         </div>

         <p-divider></p-divider>

         <div class="flex align-items-center justify-content-between">
            <div class="flex flex-column gap-1">
               <label class="font-semibold text-800">{{
                  'DATA.MODULES.INSPECTORS.SMS_CERTIFIED.CONFIG.SEND_TO_ALL_LABEL' | translate
               }}</label>
               <span class="text-500 text-xs">{{
                  'DATA.MODULES.INSPECTORS.SMS_CERTIFIED.CONFIG.SEND_TO_ALL_HELP' | translate
               }}</span>
            </div>
            <p-inputSwitch
               [ngModel]="sendToAllContacts()"
               (ngModelChange)="onSendToAllContactsChange($event)"
            ></p-inputSwitch>
         </div>

         <div *ngIf="errors().length">
            <div *ngFor="let e of errors()" class="text-red-600 text-sm">{{ e.errorMessage }}</div>
         </div>
      </div>
   </div>
</div>
